import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const contract = {
  state: {
    locale: {
      formLocale: "da-DK",
      contractLocale: "da-DK",
    },
    parties: {
      company: {
        name: "",
        cvr: "",
        address: "",
      },
      supplier: {
        name: "",
        cvr: "",
        address: "",
      },
    },
    agreement: {
      description: "",
      date: "",
    },
    violation: {
      amount: "",
    },
    applicableLaw: {
      isCourt: null,
    },
  },
  mutations: {
    updateContractLocale(state, locale) {
      state.locale.contractLocale = locale;
    },
    updateCompany(state, company) {
      state.parties.company = company;
    },
    updateSupplier(state, supplier) {
      state.parties.supplier = supplier;
    },
    updateAgreement(state, agreement) {
      state.agreement = agreement;
    },
    updateViolation(state, violation) {
      state.violation = violation;
    },
    updateApplicableLaw(state, applicableLaw) {
      state.applicableLaw = applicableLaw;
    },
  },
};

export const store = new Vuex.Store({
  modules: {
    contract,
  },
});



// WEBPACK FOOTER //
// ./src/apps/hemmelig/store.js